import * as libraryEvents from "./library/libraryEvents";
import * as peopleEvents from "./people/peopleEvents";
import * as accountsEvents from "./accounts/accountsEvents";

// merge all types of real time notification events (Library, Account and etc)
// return an array of values
const eventTypes = { ...libraryEvents, ...peopleEvents, ...accountsEvents };
export default Object.values(eventTypes);
